import Dropzone from 'dropzone';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector, useStore } from 'react-redux';
import styled from 'styled-components';
import { fileExtensionsAndMimeTypes } from '../../../utils/fileUtils';
import { remSize } from '../../../theme';
import {
  dropzoneAcceptCallback,
  dropzoneCompleteCallback
} from '../actions/uploader';

Dropzone.autoDiscover = false;

// TODO: theming for dark vs. light theme
// TODO: include color and background-color settings after migrating the themify variables.
const StyledUploader = styled.div`
  min-height: ${remSize(200)};
  width: 100%;
  text-align: center;
  .dz-preview.dz-image-preview {
    background-color: transparent;
  }
  .dz-image img {
    width: 100%;
    height: auto;
  }
  .dz-details .dz-filename:hover {
    overflow: hidden;
  }
  .dz-error-message span {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: block;
  }
  .dz-error-mark:hover {
    cursor: pointer !important;
  }
`;

function FileUploader() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const store = useStore();
  const userId = useSelector((state) => state.user.id);
  const deleteUploadErrorFiles = (uploader, file) => {
    if (file.status === 'error') {
      file.previewElement.addEventListener('click', (e) => {
        e.stopPropagation();
        uploader.removeFile(file);
      });
    }
  };
  useEffect(() => {
    const uploader = new Dropzone('div#uploader', {
      url: '/', // placeholder; nothing is POSTed under autoProcessQueue:false
      method: 'post',
      autoProcessQueue: false,
      clickable: true,
      hiddenInputContainer: '#hidden-input-container',
      maxFiles: 6,
      parallelUploads: 2,
      maxFilesize: 50, // in mb
      maxThumbnailFilesize: 8, // 8 mb
      thumbnailWidth: 200,
      thumbnailHeight: 200,
      acceptedFiles: fileExtensionsAndMimeTypes,
      dictDefaultMessage: t('FileUploader.DictDefaultMessage'),
      accept: (file, done) => {
        const state = store.getState();
        const totalSize = state.user.totalSize || state.assets?.totalSize || 0;
        // Edit-link recipient → upload to the owner's storage via the function.
        const sharedEdit =
          state.ide.shareCapability === 'edit' && state.ide.shareToken
            ? { projectId: state.project.id, token: state.ide.shareToken }
            : null;
        dropzoneAcceptCallback(
          userId,
          file,
          done,
          dispatch,
          totalSize,
          sharedEdit
        );
      }
    });
    uploader.on('complete', (file) => {
      dispatch(dropzoneCompleteCallback(file));
      deleteUploadErrorFiles(uploader, file);
    });
    return () => {
      uploader.destroy();
    };
  }, [userId, t, dispatch, store]);

  return (
    <div>
      <StyledUploader id="uploader" className="dropzone" />
      <div id="hidden-input-container" />
    </div>
  );
}

export default FileUploader;
